import * as React from "react"
import { Link } from "gatsby"

type WrapRootElementProps = {
  element: React.ReactNode;
};

const wrapRootElement = ({ element }: WrapRootElementProps) => {
  return <>{element}</>;
};

export default wrapRootElement;
